// Game state & const
import { GameState } from "@/game-rules/state.js";

// Prefabs
import { createTurnBanner } from "@/presentation/prefabs/ui/turnBanner.js";

// Kaplay helpers
import { scenesBootstrapper } from "@/presentation/helpers/scenesBootstrapper.js";

// Renderers
import { gameSceneLayout } from "@/presentation/layouts/gameSceneLayout.js";
import { renderWaterBackground } from "@/presentation/renderers/scenesWaterRenderer.js";

// Bind events
import { bindGameEvents } from "@/presentation/scenes/game/gameEventHandlers.js";
import { bindInputEvents } from "@/presentation/scenes/game/gameInputHandlers.js";

export function gameScene(k, gameConfig) {
    // If we skip the menu, assume a 3-Player Hotseat game
    const config = gameConfig || {
        mode: "HOTSEAT",
        players: 3
    };

    console.log("Game loading with config:", config);

    // ==========================================
    // SCENE SETUP
    // ==========================================
    scenesBootstrapper(k);
    renderWaterBackground(k)
    gameSceneLayout(k);

    // ==========================================
    // STATE INITIALIZATION
    // ==========================================
    const gameState = new GameState(config);

    // Hold UI references
    const uiElements = {
        duckDeckCounter: null,
        actionDeckCounter: null,
        turnBanner: createTurnBanner(k)
    };

    // ==========================================
    // BIND EVENTS
    // ==========================================
    bindGameEvents(k, gameState, uiElements);
    bindInputEvents(k, gameState);

    // ==========================================
    // START THE GAME
    // ==========================================
    gameState.startGame(config);
}